import type {editor} from 'monaco-editor';
import {useMemo} from 'react';

import type {RenderMode} from './types';

const FONT_FAMILY = [
  'ui-monospace',
  'SFMono-Regular',
  'Menlo',
  'Monaco',
  'Consolas',
  '"Liberation Mono"',
  '"Courier New"',
  'monospace',
].join(', ');

const FONT_SIZE = 13;
export const LINE_HEIGHT = 20;

const BASE_OPTIONS: editor.IDiffEditorConstructionOptions = {
  readOnly: true,
  scrollBeyondLastLine: false,
  scrollbar: {
    vertical: 'auto',
    horizontal: 'visible',
    handleMouseWheel: true,
    alwaysConsumeMouseWheel: false,
  },
  minimap: {enabled: false},
  renderOverviewRuler: false,
  overviewRulerBorder: false,
  fontSize: FONT_SIZE,
  lineHeight: LINE_HEIGHT,
  fontFamily: FONT_FAMILY,
};

/**
 * Generates configuration options for the Monaco editor. These are mostly
 * constant, but depending on the passed render mode, the `renderSideBySide`
 * option is toggled, which is important for the diff editor.
 *
 * @param renderMode
 */
export function useMonacoOptions(
  renderMode: RenderMode
): editor.IStandaloneEditorConstructionOptions {
  return useMemo(
    () => ({
      ...BASE_OPTIONS,
      renderSideBySide: renderMode === 'side-by-side',
    }),
    [renderMode]
  ) as editor.IStandaloneEditorConstructionOptions;
}
